import React, { Component, createRef, Suspense } from 'react'

/* Socket IO */
import { io } from "socket.io-client"

/* JWT */
import { decodeToken } from 'react-jwt'

/* Constants */
import { images, env, sound } from './constants'
import { LOADING, ERROR, CHOICE, WAITING } from './constants/status'
import { BET_TYPES, createEmptyBoxes, boxesFace, activeBoxes } from './constants/values'

/* UUID */
import { v4 as uuidv4 } from 'uuid'

/* Poker UI */
import { Error, Background, GameControl, Balance, Internet, GameInfo, Status, Notification, FloatingMessages, InactionTiming } from '@cuba-go/poker-ui'

/* Widgets */
import { Preloader } from './widgets'

/* Rules */
import { list as rules } from './constants/rules'
import { messages } from "./api/Support"

/* REST API */
import { history } from './api/History'

import { GamePayout, NiuTimer } from './components'

import { Bet, PlayerCards, DealerCards, PositionCard, Boxes, NiuHistory } from './widgets'

/* Intenet speed check url */
const imgUrl = "https://inbusiness.kz/uploads/2025-1/dFpAGSXY.webp"

/* WHERE EACH BOX SITS ON THE BOARD

   The hands are laid out two on a line with the third centred underneath — the shape the
   table is drawn to, see .box-cards. That row is laid out reversed and wraps on its own
   width, so the order the boxes are drawn in is what puts them in their places: the first
   drawn takes the right of the upper line, the second the left beside it, and the third
   has nowhere to go but the line below, where it is centred under the pair.

   So this is the seating, not a loop over the boxes: box 1 upper right, box 3 upper left,
   box 2 alone in the middle underneath. */
const BOX_PLACES = [0, 2, 1]

/* Fields */
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""

let hidden = null
let visibilityChange = null
if (typeof document.hidden !== 'undefined') {
    hidden = 'hidden'
    visibilityChange = 'visibilitychange'
}
else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden'
    visibilityChange = 'msvisibilitychange'
}
else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden'
    visibilityChange = 'webkitvisibilitychange'
}

/* Entry Point */
class App extends Component {


    constructor() {
        super()

        const data = decodeToken(token)

        this.state = {
            /* General */
            cached: false,
            status: LOADING,

            playerId: data.playerId,

            showTimer: false,
            innerTimeShow: true,
            currentTime: 0,

            /* The three boxes as this player holds them. Every box is open to everyone,
               so there is no seat to take and nothing to wait a turn for — and once the
               stakes are down nothing more is asked of him until the round is paid. */
            boxes: createEmptyBoxes(),

            last: null,
            list: [],
            balance: null,
            total: 0,

            boxCards: [[], [], []],
            dealerCards: [],

            /* The card pulled before the deal, and the box it sent the deal to */
            positionCard: null,
            startBox: null,

            boxGames: [null, null, null],
            dealerGame: null,

            result: [null, null, null],
            winTotal: 0,
            profit: 0,
            winType: "",

            currency: (token && data && data.currency) ? data.currency : 'USD',
            identifier: (token && data && data.identifier) ? data.identifier : '1',

            lastWin: 0,
            activeChip: 3,

            /* Dealer */
            dealerInfo: null,

            /* Game Info */
            max: data && data.max ? data.max : 5000,
            min: data && data.min ? data.min : 50,

            gameInfo: null,
            transactions: [],
            operations: [],
            histories: [],
            historyLoading: true,
            historyPage: 1,
            historyHasMore: true,

            /* Game Session */
            closed: false,
            newDevice: false,
            isDisconnected: false,
            isPaused: false,
            isClosed: false,

            /* Other */
            chips: data && data.chips && Array.isArray(data.chips) ? data.chips : [],
            backColor: data && data.backColor ? data.backColor : "",
            gameImg: data && data.gameImg ? `${env.mediapoint}/images/table-images/` + data.gameImg : null,

        }

        /* Start connection */
        this.socket = io(env.endpoint, { auth: { token: `${token}`, type: "player" } })

        /* HOW MANY TIMES THE TABLE HAS SPOKEN FOR ITSELF

           The table's picture — the phase, the cards, the hands — reaches the client two
           ways: as one snapshot when it connects or is re-synced, and as a stream of
           events while the round runs. The snapshot is applied a second and a half late,
           so a transaction notice can be read before the table redraws underneath it, and
           a round can finish inside that second and a half. Then the snapshot lands on
           top of what has already happened and undoes it.

           This counts the events, so a snapshot can tell whether it is still the newest
           thing the client knows. */
        this.live = 0

        /* Timing ref */
        this._balanceErrorTiming = null
        this._maxBetErrorTiming = null

        /* Backfround ref */
        this._background = createRef(null)

    }

    componentDidMount = () => {
        this.game()
        this.cache()
        this.loadHistory(1)
        this.loadSupportMessages()

        document.addEventListener(visibilityChange, this.handleVisibilityChange)
    }

    componentWillUnmount() {
        document.removeEventListener(visibilityChange, this.handleVisibilityChange)
        clearInterval(this.timerInterval)
    }


    handleVisibilityChange = () => {
        if (document[hidden]) {
            this.setState({ innerTimeShow: false })
        } else {
            if (this.state.currentTime > 1) {
                this.setState({ showTimer: true })
            }
            setTimeout(() => {
                this.setState({ innerTimeShow: true })
            }, 250)
        }
    }

    /* Load History */
    loadHistory = (page = 1) => {

        const { histories } = this.state

        if (page > 1) {
            this.setState({ historyPage: page })
        }

        history(token, page).then(response => {
            if (response.status === 200) {
                let list = response.data
                if (page > 1) {
                    list = [...histories, ...response.data]
                }

                if (response.data.length < 5) {
                    this.setState({ historyHasMore: false })
                }

                this.setState({ histories: list, historyLoading: false })
            }
            else {
                /* The server said no, or never answered — stop the spinner either way */
                this.setState({ historyLoading: false, historyHasMore: false })
            }
        }).catch(() => {
            this.setState({ histories: [], historyLoading: false, historyHasMore: false })
        })
    }

    /* Load Support Messages */
    loadSupportMessages = () => {
        messages(token).then(response => {
            if (response && response.status === 200) {

                /* Create Timer */
                const timer = setTimeout(() => {

                    /* Set Support Messages */
                    if (this._background && this._background.current) {
                        this._background.current.setSupportMessage(response.data)
                    }

                    /* Clear Timer */
                    clearTimeout(timer)

                }, 2100)

            }
        }).catch(() => {
            /* Support history is a nicety — the table plays on without it */
        })
    }

    /* Send Message */
    sendMessage = message => {
        this.socket.emit("messageFromPlayer", message.message)
        if (this._floatingMessages) {
            this._floatingMessages.sendMessage(message)
        }
    }

    /* Send Message */
    sendSupportMessage = message => {
        this.socket.emit("supportMessage", message.message)
    }

    game = () => {

        /* On error */
        this.socket.on("connect_error", () => {

            this.clear()

            const timer = setTimeout(() => {
                this.setState({ status: ERROR })
                clearTimeout(timer)
            }, 1000)

            this.clearTiming()
        })

        this.socket.on("disconnect", () => {
            this.setState({ isDisconnected: true })
            this.clear()
            this.clearTiming()
        })

        /* On connect */
        this.socket.on("connect", () => {
            const timer = setTimeout(() => {
                clearTimeout(timer)
                this.resetTimer()
            }, 2000)
        })

        /* On New Device */
        this.socket.on("newDeviceConnection", () => {
            this.setState({ newDevice: true })
            this.socket.disconnect()
            this.clear()
            this.clearTiming()
        })

        /* On Inaction */
        this.socket.on("setInactionState", () => {
            this.setState({ isDisconnected: true })
            this.socket.disconnect()
            this.clear()
            this.clearTiming()
        })

        /* The server lost track of this player — start over */
        this.socket.on("reloadPage", () => {
            window.location.reload()
        })

        /* On close Table */
        this.socket.on("closeTable", value => {

            if (value) {
                /* Close Notification */
                this.notify("tableClosed", "close")
                this.loadHistory(1)
                this.clear()
                this.setState({ status: WAITING })
            }

            this.setState({ isClosed: value })
        })

        /* On tableCloseNext */
        this.socket.on("tableCloseNext", () => {
            this.notify("tableClosed", "show")
        })

        /* Balance */
        this.socket.on("balance", data => {
            this.setState({ balance: data })
        })

        /* Get pause command from dealer monitor */
        this.socket.on("pause", () => {
            this.setState({ isPaused: true })
            this.notify('pause', 'show')
            this.clearTiming()
        })

        /* Continue Event */
        this.socket.on("continue", () => {
            this.setState({ isPaused: false })
            this.notify('pause', 'close')
        })


        /* ===== BETTING ===== */

        /* What the server accepted from this player's slip.

           WHAT "TOTAL BET" MEANS

           The chips the player put on the cloth, and not the money the round is holding
           against them. The table sends the hold — it has to, that is what it debited —
           and a Super Double is held at fifteen times its face, so reading the slot off
           the server had a slip of a hundred and seventy-five announcing itself as one
           thousand eight hundred and seventy-five. The hold is a real number and it is
           shown where it belongs: against the balance it came off, and per box in the
           history. The line beside the balance says "Общая ставка", so it is the stake. */
        this.socket.on("stakesSync", data => {
            if (!data) return
            const boxes = data.boxes ? data.boxes : createEmptyBoxes()
            this.setState({ boxes, total: boxesFace(boxes) })
        })

        /* The window had already shut — put the slip back the way the server has it */
        this.socket.on("stakeRejected", boxes => {
            const slip = boxes ? boxes : createEmptyBoxes()
            this.setState({ boxes: slip, total: boxesFace(slip), showTimer: false })
            this.updateTimer()
        })

        /* The slip the operator actually took */
        this.socket.on("playerAnte", boxes => {
            if (Array.isArray(boxes)) {
                this.setState({ boxes })
            }
        })

        this.socket.on("lastStake", data => {
            this.setState({ last: data })
        })


        /* ===== GAME FLOW ===== */

        this.socket.on("status", data => {

            this.live = this.live + 1

            const { status, timer } = data

            if (status !== this.state.status) {
                this.setState({ status })
            }

            /* No round runs without a dealer, so neither does a countdown */
            if (timer && this.state.dealerInfo) {
                this.updateTimer()
                this.setState({ showTimer: true, currentTime: timer })
                this.checkTimer(timer)
            }
            else {
                /* This window is not this player's — whatever was counting must go, or it
                   keeps running under the next hand and never restarts for it */
                this.stopTimer()
            }

            if (status === CHOICE && this.state.status !== CHOICE) {
                this.loadHistory(1)
                this.setState({ isClosed: false })
                this.notify("tableClosed", "close")
            }
        })

        /* A round ended and the table was wiped */
        this.socket.on("clearData", () => {
            this.live = this.live + 1
            this.clear()
        })

        this.socket.on("forceEnd", () => {

            this.notify("pause", "close")

            const timer = setTimeout(() => {
                this.notify("forceEnd", "show")

                const close = setTimeout(() => {
                    this.notify("forceEnd", "close")
                    clearTimeout(close)
                }, 4000)

                clearTimeout(timer)
            }, 2000)

            this.clear()
        })

        /* The last stake came off the table — the countdown goes away until someone bets again */
        this.socket.on("hideTimer", () => {
            this.stopTimer()
        })

        /* Reconnection */
        this.socket.on("reconnection", data => {

            if (!data) return

            let time = 1500

            if (data.reason && data.reason === "transaction") {
                this.notify("transaction", 'show')
                time = 3000
            }

            const status = data.status

            const boxes = data.boxes ? data.boxes : createEmptyBoxes()

            /* Where the table's account of itself stood when this snapshot arrived */
            const taken = this.live

            setTimeout(() => {

                /* THE SNAPSHOT YIELDS TO ANYTHING NEWER THAN ITSELF

                   It describes the table as it was a second and a half ago. If the table
                   has said anything since, that is the newer word and this is history: a
                   round that ended inside the wait had its cards wiped and its phase moved
                   to the open betting window, and writing the snapshot over that put the
                   finished round's cards back with the bets open. box() draws the cards
                   whenever there are any, so the chip tray then went undrawn for the whole
                   of the window and the round after it — while the countdown ran and the
                   spots on the cloth went on taking bets.

                   What the snapshot alone carries — the dealer, the round's own details,
                   the money already moved — is still worth having and is applied either
                   way. Only its picture of the table is dropped. */
                const stale = this.live !== taken

                const table = stale ? {} : {
                    status,
                    boxes,
                    total: boxesFace(boxes),
                    boxCards: data.boxCards ? data.boxCards : [[], [], []],
                    boxGames: data.boxGames ? data.boxGames : [null, null, null],
                    dealerCards: data.dealerCards ? data.dealerCards : [],
                    positionCard: data.positionCard ? data.positionCard : null,
                    startBox: (data.startBox === 0 || data.startBox) ? data.startBox : null,
                    dealerGame: data.dealerGame,
                }

                this.setState({
                    isClosed: data.isClosed,
                    gameInfo: data.gameInfo,
                    last: data.last ? data.last : null,
                    transactions: data.transactions ? data.transactions : [],
                    dealerInfo: data.dealerData,
                    ...table,
                })

                if (!stale) {
                    this.updateResult(data.result, data.winTotal, data.profit)
                }

                setTimeout(() => {

                    /* The clock is part of that picture — a live status event has already
                       set it, and more correctly than a second-and-a-half-old number */
                    if (stale) return

                    /* An idle table hands out no timer — the clock only moves under a dealer */
                    const running = data.timer && data.dealerData

                    this.setState({
                        showTimer: running ? true : false,
                        currentTime: running ? parseInt(data.timer) - 1 : 0,
                    })

                    if (running) {
                        this.checkTimer(data.timer)
                    }
                }, 200)

                if (data.isPaused) {
                    this.notify("pause", "show")
                }
                else {
                    this.notify("pause", 'close')
                }

                this.notify("transaction", 'close')

            }, time)

        })

        /* Get a dealer Info */
        this.socket.on("dealerData", data => {
            this.setState({ dealerInfo: data })
        })


        /* ===== CARDS ===== */

        this.socket.on("boxCards", data => {
            this.live = this.live + 1
            this.setState({ boxCards: data })
        })

        this.socket.on("boxGames", data => {
            this.live = this.live + 1
            this.setState({ boxGames: data })
        })

        this.socket.on("dealerCards", data => {
            this.live = this.live + 1
            this.setState({ dealerCards: data })
        })

        this.socket.on("dealerGame", data => {
            this.live = this.live + 1
            this.setState({ dealerGame: data })
        })

        /* The card pulled before the deal, saying which box it starts at */
        this.socket.on("positionCard", data => {
            if (!data) return
            this.live = this.live + 1
            this.setState({
                positionCard: data.card ? data.card : null,
                startBox: (data.startBox === 0 || data.startBox) ? data.startBox : null
            })
        })


        /* Result */
        this.socket.on("resultData", data => {
            const { result, win, profit } = data
            this.updateResult(result, win, profit)
        })

        /* Message */
        this.socket.on("message", data => {
            if (this._floatingMessages) {
                this._floatingMessages.sendMessage(data)
            }
            if (this._background && this._background.current) {
                this._background.current.addMessage(data)
            }
        })

        /* On Support Message */
        this.socket.on("adminSupportAnswer", data => {
            if (this._floatingMessages) {
                this._floatingMessages.sendMessage(data)
            }
            if (this._background && this._background.current) {
                this._background.current.addSupportMessage(data)
            }
        })

        /* Notification */
        this.socket.on("gameInfo", data => {
            this.setState({ gameInfo: data })
        })

        /* Get Game Info */
        this.socket.on("refund", data => {
            this.notify("refund", "refund", { type: "refund", total: data })
        })

        /* Get transactions list */
        this.socket.on("transaction", data => {
            if (data.id) {
                const { transactions, operations } = this.state
                let list = [data, ...transactions]
                let operationsList = [data, ...operations]
                this.setState({ transactions: list, operations: operationsList })

                setTimeout(() => {
                    let operationsList = this.state.operations
                    operationsList = operationsList.filter(item => item.id !== data.id)
                    this.setState({ operations: operationsList })
                }, 3500)

            }
        })

        this.socket.on("editTransaction", data => {
            const { transactions } = this.state
            let list = transactions
            const index = list.findIndex(e => e.number === data.number)
            if (index > -1) {
                list[index].status = data.status
                this.setState({ transactions: list })
            }
        })

    }

    /* Clear timing to remove sound */
    clearTiming = () => {
        if (this._timing) {
            this._timing.clear()
        }
        setTimeout(() => {
            if (this._timing) {
                this._timing.clear()
            }
        }, 1500)
    }

    /* Show and close notifications */
    notify = (type, action, data = null) => {

        const notifyData = { type, action, data }

        if (this._notify) {
            this.notifyAction(notifyData)
        }
        else {
            setTimeout(() => {
                if (this._notify) {
                    this.notifyAction(notifyData)
                }
            }, 2000)
        }

    }

    /* Do notify actions after notify component check */
    notifyAction = (notifyData) => {

        const { type, action, data = null } = notifyData

        if (action === "show") {
            this._notify.show(type)
        }
        else if (action === 'close') {
            this._notify.close(type)
        }
        else if (action === 'refund') {
            if (data.total) {
                const title = data.type === 'refund' ? 'Возврат средств' : "Пополнение суммы"
                this._notify.refund({ title, total: data.total, uid: uuidv4() })
            }
        }

    }

    /* Check internet speed */
    checkInternetSpeed = (speed) => {
        if (parseInt(speed) < 5) {
            this.notify('internet', 'show')
        }
        else {
            this.notify('internet', 'close')
        }
    }


    /* Stop the countdown and take it off the screen */
    stopTimer = () => {
        this.updateTimer()
        this.setState({ showTimer: false, currentTime: 0 })
    }

    /* Reset top timing */
    updateTimer = () => {
        clearInterval(this.timerInterval)
        this.timerInterval = null
        this.setState({ currentTime: 0 })
    }

    checkTimer = (timer) => {

        if (!timer || timer <= 1) return

        let current = timer

        this.timerInterval = setInterval(() => {

            current -= 1
            this.setState({ currentTime: current })

            /* The last seconds of the betting window are the only ones that press anybody:
               past them there is nothing left for the player to do but watch */
            if (current > 0 && current < 5) {
                sound.play('tic', 0.5)
            }

            if (current <= 0) {
                this.setState({ showTimer: false })
                this.updateTimer()
            }

        }, 1000)

    }

    /* Cache images */
    cache = async () => {

        const promises = images.data.map(uri => {

            return new Promise(function (resolve, reject) {
                const img = new Image()
                img.src = uri
                img.onload = resolve()
                img.onerror = reject()
            })

        })

        await Promise.all(promises)

        this.setState({ cached: true })
    }

    /* Reset top timing */
    resetTimer = () => {
        if (this._inaction) {
            this._inaction.reset()
        }
    }

    /* Disconnect user when inaction timer equal to 0 */
    setInactionState = () => {
        this.setState({ closed: true })
        this.socket.disconnect()
        this.clear()
    }


    /* Toggle Balance Error */
    toggleBalanceError = () => {

        if (!this._balanceErrorTiming) {
            this.notify('balanceError', 'show')
        }

        if (this._balanceErrorTiming) {
            clearTimeout(this._balanceErrorTiming)
            this._balanceErrorTiming = null
        }

        this._balanceErrorTiming = setTimeout(() => {
            this.notify('balanceError', 'close')
            clearTimeout(this._balanceErrorTiming)
            this._balanceErrorTiming = null
        }, 2000)

        sound.play("blocked")

    }

    /* Toggle Max Bet Error */
    toggleMaxBetError = () => {

        if (!this._maxBetErrorTiming) {
            this.notify('maxBetError', 'show')
        }

        if (this._maxBetErrorTiming) {
            clearTimeout(this._maxBetErrorTiming)
            this._maxBetErrorTiming = null
        }

        this._maxBetErrorTiming = setTimeout(() => {
            this.notify('maxBetError', 'close')
            clearTimeout(this._maxBetErrorTiming)
            this._maxBetErrorTiming = null
        }, 2000)

        sound.play("blocked")

    }

    /* The round paid out — a player may have won on one box and lost on another, so the
       banner reads the round as a whole: he is up on it, or he is not.

       "win" is what came back onto the balance, reserve and all; "profit" is what he is up
       by. The two differ by the hold, which was never really his to lose. */
    updateResult = (result, sum, profit = 0) => {

        if (!result || !Array.isArray(result)) return

        this.setState({ result })

        let played = false

        result.forEach(item => {
            if (item) played = true
        })

        if (played) {

            const win = profit > 0 ? "win" : "lose"

            this.setState({ winTotal: sum, profit, winType: win, lastWin: sum })

            if (win === "win") {
                sound.play('winsmall', 0.5)
            }
        }


    }

    /* Put the whole three box slip on the table */
    setBoxes = boxes => {

        const { isClosed, status } = this.state

        if (isClosed || status !== CHOICE) {
            sound.play("blocked")
            return
        }

        const face = boxesFace(boxes)

        const next = { boxes, total: face }

        /* THE ONE SLOT BESIDE THE BALANCE CHANGES HANDS HERE

           It holds two things at two different times: what the last round paid the player,
           and what he has on the cloth now. Balance in poker-ui chooses between them by
           reading the payout first and falling back to the stake only when there is none,
           so the payout has to be put away by hand for the stake to be seen at all. It
           never was, and once a player had been paid the slot said so for the rest of his
           session — he could not see his own stake while placing it or while the hand was
           played.

           What claims the slot is the first chip going down, not the window opening. A
           player sitting this round out, or only watching the table, has no stake to put
           there and would rather go on seeing what he was last paid. */
        if (face > 0) {
            next.lastWin = 0
        }

        this.setState(next)

        this.socket.emit("stakes", boxes.map(box => {
            const stake = {}
            BET_TYPES.forEach(type => { stake[type] = box[type] })
            return stake
        }))

        sound.play("sound")
        this.resetTimer()
    }

    /* Leave the table */
    quitGame = () => {
        this.socket.disconnect()
        this.setState({ closed: true })
        this.clear()
    }

    /* Clear all variables */
    clear = () => {

        this.setState({
            showTimer: false,
            currentTime: 0,

            boxes: createEmptyBoxes(),

            list: [],
            total: 0,

            boxCards: [[], [], []],
            dealerCards: [],

            /* The card pulled before the deal, and the box it sent the deal to */
            positionCard: null,
            startBox: null,

            boxGames: [null, null, null],
            dealerGame: null,

            result: [null, null, null],
            winTotal: 0,
            profit: 0,
            winType: "",

            gameInfo: null,
            transactions: []
        })
    }

    /* Dealer Cards */
    _dealer_cards = () => {

        const { dealerCards, dealerGame } = this.state

        return <DealerCards cards={dealerCards} game={dealerGame} style="" />
    }

    /* The card that said where the deal begins */
    _position_card = () => {

        const { positionCard, startBox } = this.state

        return <PositionCard card={positionCard} startBox={startBox} />
    }

    /* Player Cards — all three boxes are dealt every round, so all three are drawn.
       The ones this player has money on stand out from the ones he is only watching. */
    _player_cards = index => {

        const { boxCards, boxGames, boxes } = this.state

        const held = activeBoxes(boxes)

        return (
            <PlayerCards
                cards={boxCards && boxCards[index] ? boxCards[index] : []}
                game={boxGames && boxGames[index] ? boxGames[index] : null}
                box={index}
                boxState={held.includes(index)}
                staked={held.length > 0}
                key={`box-c-${index}`}
            />
        )
    }

    /* Draw Result */
    _result = () => {

        const { winTotal, winType, currency } = this.state

        if (winType && winType.length > 0) {
            return <Status status="result" data={{ sum: winTotal, result: winType, reason: 'bet' }} currency={currency} />
        }
    }

    /* THE BET PANEL — the buttons and the tray of chips to pick from */
    betPanel = () => {

        const { boxes, last, total, activeChip, balance, currency, max, min, chips, backColor, list, currentTime, isClosed } = this.state

        return (
            <Suspense>
                <Bet
                    boxes={boxes}
                    last={last}
                    total={total}
                    active={activeChip}
                    setActiveChip={data => this.setState({ activeChip: data })}
                    setBoxes={data => this.setBoxes(data)}
                    balance={balance}
                    currency={currency}
                    toggleBalanceError={() => this.toggleBalanceError()}
                    toggleMaxBetError={() => this.toggleMaxBetError()}
                    isChoice={true}
                    max={max}
                    min={min}
                    chips={chips}
                    backColor={backColor}
                    list={list}
                    setList={data => this.setState({ list: data })}
                    currentTime={currentTime}
                    isClosed={isClosed}
                />
            </Suspense>
        )
    }

    box = () => {

        const { status, boxCards, dealerCards, positionCard } = this.state

        /* The hands on the table are shared by everyone, so what is drawn follows the cards
           rather than this player's own standing — a spectator watches the same three boxes.
           The position card is the first thing off the shoe, so it is what opens the board. */
        const dealt = (boxCards && boxCards.some(cards => cards && cards.length > 0))
            || (dealerCards && dealerCards.length > 0)
            || !!positionCard

        /* AN OPEN BETTING WINDOW IS ASKED FIRST

           The two are meant to be exclusive: the round's cards are collected and wiped
           before the bets are opened again, so an open window and cards on the table
           cannot both be true of the same moment. When they are, it is the client holding
           something out of date, and of the two the window is the one the player can still
           act on — he has a countdown running and spots on the cloth that take his chips,
           and no tray to pick a chip from is the one thing he cannot work around. */
        if (status === CHOICE) {
            return this.betPanel()
        }

        if (dealt) {
            return (
                <div className='play'>

                    {this._result()}

                    <div className="card-box">

                        <div className="niu-dealer-row">
                            {this._position_card()}
                            {this._dealer_cards()}
                        </div>

                        <div className="card-box-bottom">
                            <div className='box-cards'>
                                {BOX_PLACES.map(index => this._player_cards(index))}
                            </div>
                        </div>

                    </div>

                </div>
            )
        }

        return <div className='play' />
    }



    render = () => {

        const { status, boxes, result, winType, showTimer, currentTime, innerTimeShow, activeChip, cached, dealerInfo, currency, total, balance, lastWin, transactions, gameInfo, list, operations, histories, historyPage, historyHasMore, closed, newDevice, max, min, isDisconnected, isPaused, identifier, backColor, gameImg, chips, isClosed } = this.state

        /* A win of this player's own — the timer steps aside for it */
        const resultVisible = winType === "win"

        const gamePayout = <GamePayout currency={currency} max={max} min={min} />

        const playing = activeBoxes(boxes).length > 0

        const notificationStatus =
            isClosed ? "tableClosedFinal" :
                !dealerInfo
                    ? "dealer"
                    : (status !== CHOICE && !playing) ? "waiting" : ""

        let content = (
            <Background token={token} gameType="niuniu" ref={this._background} historyComponent={NiuHistory} gamePlace={env.gamePlace} currency={currency} status={status} dealer={dealerInfo} sendMessage={message => this.sendMessage(message)} sendSupportMessage={message => this.sendSupportMessage(message)} info={gameInfo} transactions={transactions} histories={histories} loadMore={() => this.loadHistory(historyPage + 1)} historyHasMore={historyHasMore} identifier={identifier} rules={rules} gamePayout={gamePayout} videoBackImg={gameImg} textileColor={backColor}>

                {showTimer && !resultVisible ? <NiuTimer status={status} currentTime={currentTime} innerTimeShow={innerTimeShow} hide={() => this.setState({ showTimer: false })} /> : null}
                <InactionTiming time={240} ref={ref => this._inaction = ref} status={status} isPaused={isPaused} setInactionState={() => this.setInactionState()} />

                <GameInfo currency={currency} info={gameInfo} operations={operations} />
                <GameControl title={`NIU NIU 3 BOX`} max={max} min={min} currency={currency} info={gameInfo} data={dealerInfo} gamePayout={gamePayout} onQuitGame={() => this.quitGame()} />
                <Balance balance={balance} total={total} lastWin={lastWin} currency={currency} />
                <FloatingMessages ref={ref => this._floatingMessages = ref} />

                <Suspense>
                    {this.box()}
                </Suspense>

                <Suspense>
                    <Boxes
                        dealerInfo={dealerInfo}
                        isChoice={status === CHOICE}
                        boxes={boxes}
                        backColor={backColor}
                        active={activeChip}
                        chips={chips}
                        currency={currency}
                        setBoxes={data => this.setBoxes(data)}
                        balance={balance}
                        max={max}
                        toggleBalanceError={() => this.toggleBalanceError()}
                        toggleMaxBetError={() => this.toggleMaxBetError()}
                        list={list}
                        setList={list => this.setState({ list })}
                        result={result}
                        isClosed={isClosed}
                    />
                </Suspense>

                <Notification notificationStatus={notificationStatus} ref={ref => this._notify = ref} currency={currency} max={max} />

                <Internet url={imgUrl} setInternetSpeed={data => this.checkInternetSpeed(data)} />

            </Background>
        )

        if (status === ERROR || newDevice || closed || isDisconnected) {
            content = <Error newDevice={newDevice} closed={closed} isDisconnected={isDisconnected} />
        }

        if (status === LOADING || !cached) {
            content = <Preloader url={gameImg} />
        }

        return content
    }

}

export default App
